import _ceil from 'lodash/ceil';
import _orderBy from 'lodash/orderBy';
import dayjs from 'dayjs';
import dao from '../../../dao/skuDao';
import lookDao from '../../../dao/lookDao';
import smbUtils from '../../../utils/smbUtils';
import productDao from '../../../dao/productDao';

const LIST_SKUS = 'pages/products/listskus/LIST_SKUS';
const LIST_SKUS_SUCCESS = 'pages/products/listskus/LIST_SKUS_SUCCESS';
const PAGE = 'pages/products/listskus/PAGE';
const SIZE = 'pages/products/listskus/Size';
const SORT = 'pages/products/listskus/SORT';
const DELETE_SKU = 'pages/products/listskus/DELETE_SKU';
const DELETE_SKU_SUCCESS = 'pages/products/listskus/DELETE_SKU_SUCCESS';
const ENABLE_SKU = 'pages/products/listskus/ENABLE_SKU';
const ENABLE_SKU_SUCCESS = 'pages/products/listskus/ENABLE_SKU_SUCCESS';
const DISABLE_SKU = 'pages/products/listskus/DISABLE_SKU';
const DISABLE_SKU_SUCCESS = 'pages/products/listskus/DISABLE_SKU_SUCCESS';
const COPY_SKU = 'pages/products/listskus/COPY_SKU';
const COPY_SKU_SUCCESS = 'pages/products/listskus/COPY_SKU_SUCCESS';
const SEARCH = 'pages/products/listskus/SEARCH';
const RESET_SEARCH = 'pages/products/listskus/RESET_SEARCH';
const FILTER_SKUS = 'pages/products/listskus/FILTER_SKUS';
const FILTER_SKUS_SUCCESS = 'pages/products/listskus/FILTER_SKUS_SUCCESS';
const COUNT_ENABLED = 'pages/products/listskus/COUNT_ENABLED';
const COUNT_ENABLED_SUCCESS = 'pages/products/listskus/COUNT_ENABLED_SUCCESS';
const LIST_LOOK_SKUIDS = 'pages/products/listskus/LIST_LOOK_SKUIDS';
const LIST_LOOK_SKUIDS_SUCCESS =
  'pages/products/listskus/LIST_LOOK_SKUIDS_SUCCESS';
const LIST_PRODUCT_SKUIDS = 'pages/products/listskus/LIST_PRODUCT_SKUIDS';
const LIST_PRODUCT_SKUIDS_SUCCESS =
  'pages/products/listskus/LIST_PRODUCT_SKUIDS_SUCCESS';

const initialState = {
  skus: [],
  allSkus: [],
  isLoaded: false,
  grid: {
    sort: 'createdTime',
    asc: false,
    pageIndex: 1,
    pageSize: 10,
    querySize: 100,
    pages: 1,
    totalSize: 0,
  },
  numberOfEnabled: null,
  searchParams: {},
  lookSkuIds: [],
  productSkuIds: [],
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LIST_SKUS:
      return {
        ...state,
        isLoaded: false,
      };
    case LIST_SKUS_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        skus: action.json.results,
        allSkus: action.json.results,
      };
    case DELETE_SKU:
      return {
        ...state,
      };
    case DELETE_SKU_SUCCESS:
      return {
        ...state,
      };
    case ENABLE_SKU:
      return {
        ...state,
      };
    case ENABLE_SKU_SUCCESS:
      return {
        ...state,
      };
    case DISABLE_SKU:
      return {
        ...state,
      };
    case DISABLE_SKU_SUCCESS:
      return {
        ...state,
      };
    case COPY_SKU:
      return {
        ...state,
      };
    case COPY_SKU_SUCCESS:
      return {
        ...state,
      };
    case FILTER_SKUS:
      return {
        ...state,
      };
    case FILTER_SKUS_SUCCESS:
      return {
        ...state,
        skus: action.json,
        grid: {
          ...state.grid,
          totalSize: action.json.length,
          pages: _ceil(action.json.length / state.grid.pageSize),
        },
      };
    case PAGE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageIndex: action.pageIndex,
        },
      };
    case SIZE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageSize: action.pageSize,
          pages: _ceil(state.allSkus.length / action.pageSize),
          pageIndex: 1,
        },
      };
    case SORT:
      return {
        ...state,
        grid: {
          ...state.grid,
          sort: action.sort,
          asc: state.grid.sort === action.sort ? !state.grid.asc : false,
        },
      };
    case SEARCH:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.params,
        },
        grid: {
          ...state.grid,
          pageIndex: 1,
        },
      };
    case RESET_SEARCH:
      return {
        ...state,
        searchParams: {},
      };
    case COUNT_ENABLED:
      return {
        ...state,
        numberOfEnabled: null,
      };
    case COUNT_ENABLED_SUCCESS:
      return {
        ...state,
        numberOfEnabled: action.numberOfEnabled,
      };
    case LIST_LOOK_SKUIDS:
      return {
        ...state,
        lookSkuIds: [],
      };
    case LIST_LOOK_SKUIDS_SUCCESS:
      return {
        ...state,
        lookSkuIds: action.lookSkuIds,
      };
    case LIST_PRODUCT_SKUIDS:
      return {
        ...state,
        productSkuIds: [],
      };
    case LIST_PRODUCT_SKUIDS_SUCCESS:
      return {
        ...state,
        productSkuIds: action.productSkuIds,
      };
    default:
      return state;
  }
};

export function listSkus() {
  return (dispatch, getState) => {
    dispatch({
      type: LIST_SKUS,
    });
    return dao
      .listAllSkus(buildQueryString(getState()))
      .then((json) => dispatch(listSkusSuccess(json)));
  };
}

function listSkusSuccess(json) {
  return (dispatch) => {
    dispatch({
      type: LIST_SKUS_SUCCESS,
      json,
    });
    return dispatch(filterSkus());
  };
}

export function enableSku(skuId) {
  return (dispatch) => {
    dispatch({
      type: ENABLE_SKU,
    });
    // return dao.enableSku(skuId);
    return dao.enableSku(skuId).then((json) => {
      dispatch(enableSkuSuccess(json));
      return {status: 'success'};
    });
  };
}

function enableSkuSuccess(json) {
  return (dispatch) => {
    dispatch(listSkus());
    return dispatch({
      type: ENABLE_SKU_SUCCESS,
      json,
    });
  };
}

export function disableSku(skuId) {
  return (dispatch) => {
    dispatch({
      type: DISABLE_SKU,
    });
    return dao.disableSku(skuId).then((json) => {
      dispatch(disableSkuSuccess(json));
      return {status: 'success'};
    });
  };
}

function disableSkuSuccess(json) {
  return (dispatch) => {
    dispatch(listSkus());
    return dispatch({
      type: DISABLE_SKU_SUCCESS,
      json,
    });
  };
}

function buildQueryString(rootState) {
  const grid = rootState.pages.products.listskus.grid;
  return {
    sortBy: grid.sort,
    asc: grid.asc,
    pageIndex: initialState.grid.pageIndex,
    pageSize: grid.querySize,
  };
}

export function deleteSku(productId) {
  return (dispatch) => {
    dispatch({
      type: DELETE_SKU,
    });
    return dao.deleteSku(productId).then((json) => {
      dispatch(deleteSkuSuccess(json));
      dispatch(countEnabled());
    });
  };
}

function deleteSkuSuccess(json) {
  return (dispatch) => {
    dispatch(listSkus());
    return dispatch({
      type: DELETE_SKU_SUCCESS,
      json,
    });
  };
}

export function copySku(skuId) {
  return (dispatch) => {
    dispatch({
      type: COPY_SKU,
    });
    return dao.copySku(skuId).then((json) => {
      dispatch(copySkuSuccess(json));
      dispatch(countEnabled());
    });
  };
}

function copySkuSuccess(json) {
  return (dispatch) => {
    dispatch(listSkus());
    return dispatch({
      type: COPY_SKU_SUCCESS,
      json,
    });
  };
}

function filterSkus() {
  return (dispatch, getState) => {
    const grid = getState().pages.products.listskus.grid;
    let skus = getState().pages.products.listskus.allSkus;
    const filterParams = smbUtils.omit(
      getState().pages.products.listskus.searchParams
    );
    if (filterParams.skuNo) {
      skus = skus.filter(
        (s) =>
          s.skuNo && s.skuNo.search(new RegExp(filterParams.skuNo, 'i')) !== -1
      );
    }
    if (filterParams.skuName) {
      skus = skus.filter((s) =>
        s.skuName
          ? s.skuName.search(new RegExp(filterParams.skuName, 'i')) !== -1
          : s.i18n &&
            s.i18n.enu &&
            s.i18n.enu.skuName.search(new RegExp(filterParams.skuName, 'i')) !==
              -1
      );
    }
    if (filterParams.skuType) {
      skus = skus.filter((s) => s.skuType === filterParams.skuType);
    }
    if (filterParams.colorCode) {
      skus = skus.filter((s) => {
        const cs = s.color ? [s.color] : s.colors.map((c) => c.color);
        const r = cs.map(
          (c) => c.search(new RegExp(filterParams.colorCode, 'i')) !== -1
        );
        return r.indexOf(true) !== -1;
      });
    }
    if (filterParams.createdTimeFrom) {
      skus = skus.filter((s) => {
        const from = dayjs(filterParams.createdTimeFrom).valueOf();
        const to = dayjs(filterParams.createdTimeTo).valueOf();
        const createdTime = dayjs(s.createdTime).valueOf();
        return from <= createdTime && createdTime <= to;
      });
    }
    if (filterParams.lastModifiedFrom) {
      skus = skus.filter((s) => {
        const from = dayjs(filterParams.lastModifiedFrom).valueOf();
        const to = dayjs(filterParams.lastModifiedTo).valueOf();
        const createdTime = dayjs(s.createdTime).valueOf();
        return from <= createdTime && createdTime <= to;
      });
    }
    if (filterParams.enabled) {
      skus = skus.filter(
        (s) => String(s.enabled) === String(filterParams.enabled)
      );
    }
    skus = _orderBy(skus, grid.sort, grid.asc ? 'asc' : 'desc');
    return dispatch(filterSkusSuccess(skus));
  };
}

function filterSkusSuccess(json) {
  return {
    type: FILTER_SKUS_SUCCESS,
    json,
  };
}

export function page(params) {
  return {
    type: PAGE,
    pageIndex: params.selected + 1,
  };
}

export function size(pageSize) {
  return {
    type: SIZE,
    pageSize,
  };
}

export function sort(sort) {
  return (dispatch) => {
    dispatch({
      type: SORT,
      sort,
    });
    return dispatch(filterSkus());
  };
}

export function search(params) {
  return (dispatch) => {
    dispatch({
      type: SEARCH,
      params,
    });
    return dispatch(filterSkus());
  };
}

export function resetSearch() {
  return (dispatch) => {
    dispatch({
      type: RESET_SEARCH,
    });
    return dispatch(filterSkus());
  };
}

export function countEnabled() {
  return (dispatch) => {
    dispatch({type: COUNT_ENABLED});
    return dao.countEnabled().then((r) => {
      dispatch({type: COUNT_ENABLED_SUCCESS, numberOfEnabled: r.count});
    });
  };
}

export function listLookSkuIds() {
  return (dispatch) => {
    dispatch({
      type: LIST_LOOK_SKUIDS,
    });
    return lookDao
      .listSkuIds()
      .then((skuIds) => dispatch(listLookSkuIdsSuccess(skuIds)));
  };
}

function listLookSkuIdsSuccess(lookSkuIds) {
  return {
    type: LIST_LOOK_SKUIDS_SUCCESS,
    lookSkuIds,
  };
}

export function listProductSkuIds() {
  return (dispatch) => {
    dispatch({
      type: LIST_PRODUCT_SKUIDS,
    });
    return productDao
      .listProductSkuIds()
      .then((skuIds) => dispatch(listProductSkuIdsSuccess(skuIds)));
  };
}

function listProductSkuIdsSuccess(productSkuIds) {
  return {
    type: LIST_PRODUCT_SKUIDS_SUCCESS,
    productSkuIds,
  };
}
